export default __webpack_public_path__ + "cbdb4851e97963c6387c0c82286fbfec.svg";